module.exports = __webpack_public_path__ + "img/img22.e1e1fa6d.jpg";